<template>
  <div>
  <div v-if="!selectedIlotId" class="wrap has-error">
    Attention : pour interpréter les résultats en <b>Vue par culture</b> affichés pour « <b>Tous les ilots</b> », les cultures de tous les ilots doivent être différenciées en particulier si elles présentent des conditions d'irrigation distinctes.
    <br />Veillez à différencier les cultures de tous les ilots en remplissant le champ « <b>Complément d’information</b> » dans le paramétrage des cultures.
  </div>
  <table class='max-70' >
    <thead>
      <tr>
        <th class="head-param">Calcul<br />
          <v-multiselect
            class="result-ilot"
            v-model="selectedParam"
            :options="rows"
            label="label"
            track-by="key"
            placeholder="Sélectionner un paramètre"
            :searchable="false"
            :allow-empty="false"
            :showLabels="false">
          </v-multiselect>
        </th>
        <th v-for='scenario in scenarios' :key='scenario.id_scenario'> {{ scenario.nom }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for='culture in cultures' :key='culture.id_culture'>
        <td>{{culture.nom}} <span>{{culture.complement}}</span></td>
        <td class="numeric-data" v-for='scenario in scenarios' :key='scenario.id_scenario + "-" + culture.id_culture'> {{ getValeur(scenario.id_scenario, culture.id_culture) | formatNumeric }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="secondaire" :colspan="scenarios.length + 1">
          <label v-if="selectedParam.afficherAide === true">
            <input type="checkbox" v-model="avecAide" />
            Aide incluse
          </label>
        </td>
      </tr>
    </tfoot>
  </table>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SimulationResultatCulture',

  data () {
    const rows = [
      { key: 'marge_med', key_aide: 'marge_med_aide', label: 'Marge nette médiane (€/ha)', afficherAide: true },
      { key: 'marge_moy', key_aide: 'marge_moy_aide', label: 'Marge nette moyenne (€/ha)', afficherAide: true },
      { key: 'rdt_med', key_aide: 'rdt_med', label: 'Rendement médian (q/ha)' },
      { key: 'rdt_moy', key_aide: 'rdt_moy', label: 'Rendement moyen (q/ha)' },
      { key: 'conso_med', key_aide: 'conso_med', label: 'Volume eau median consommé (m³)' },
      { key: 'conso_moy', key_aide: 'conso_moy', label: 'Volume eau moyen consommé (m³)' },
      { key: 'conso_med_ha', key_aide: 'conso_med_ha', label: 'Volume eau médian consommé (m³/ha)' },
      { key: 'conso_moy_ha', key_aide: 'conso_moy_ha', label: 'Volume eau moyen consommé (m³/ha)' }
    ]
    return {
      resultat: null,
      rows,
      selectedParam: rows[0],
      avecAide: true
    }
  },

  computed: {
    ...mapGetters(['selectedIlotId']),
    scenarios () {
      return this.$store.state.simulation.currentSimulation.scenarios
    },
    cultures () {
      return this.$store.getters.getCultures.filter(c => ((this.resultat || []).some(r => r.id_culture === c.id_culture)))
    },
    message () {
      return 'Les marges nettes sont hors aides'
    },
    surface () {
      return this.$store.state.simulation.filtreIlot.sau
    }
  },

  created () {
    this.loadResult()
  },

  methods: {
    ...mapActions(['loadByCulture', 'getExportForCSV']),

    loadResult () {
      this.loadByCulture()
        .then(data => (this.resultat = data))
    },
    getValeur (idScenario, idCulture) {
      if (!this.resultat) {
        return ''
      }
      const record = this.resultat.find(data => data.id_scenario === idScenario && data.id_culture === idCulture)
      if (!this.selectedParam || !record) {
        return ''
      }
      const key = this.selectedParam[this.avecAide ? 'key_aide' : 'key']
      return record[key] || ''
    }
  }
}
</script>

<style lang="scss">
  div.v-select.result-ilot {
    display: inline-block;
    width: 100%;
  }
</style>
